import { StagewiseToolbar as Toolbar } from '@stagewise/toolbar-react';

const stagewiseConfig = {
  plugins: []
};

export function StagewiseToolbar() {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return <Toolbar config={stagewiseConfig} />;
} 